import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DebounceService {
  private searchSubject = new Subject<string>();
  private loadingSubject = new BehaviorSubject<boolean>(false); 

  search$ = this.searchSubject.asObservable().pipe(debounceTime(2000)); // 2 sec delay
  loading$ = this.loadingSubject.asObservable(); // Observable for loader state

  triggerSearch(searchTerm: string) {
    if (searchTerm.length >= 2) { // Only trigger if at least 2 characters are entered
      this.loadingSubject.next(true); // Show loader
      this.searchSubject.next(searchTerm);
    }
  }

  setLoading(isLoading: boolean) {
    this.loadingSubject.next(isLoading); // Manage loader state
  }
}
